module.exports = __webpack_public_path__ + "static/img/yike.5c95223c.png";